// extracted by mini-css-extract-plugin
module.exports = {"ctoButton":"CellularCapability_ctoButton__1HxWj","noHoverBg":"CellularCapability_noHoverBg__1SXs5"};